interface SparklineProps {
  data: number[]
  color?: string
  height?: number
}

export function Sparkline({ data, color = 'var(--ns-brand-strong)', height = 28 }: SparklineProps) {
  if (data.length < 2) return null
  const max   = Math.max(...data)
  const min   = Math.min(...data)
  const range = Math.max(1, max - min)
  const w     = 100
  const points = data
    .map((v, i) => {
      const x = (i / (data.length - 1)) * w
      const y = height - 4 - ((v - min) / range) * (height - 8)
      return `${x},${y}`
    })
    .join(' ')
  const areaPoints = `0,${height} ${points} ${w},${height}`

  return (
    <svg className="spark" viewBox={`0 0 ${w} ${height}`} preserveAspectRatio="none">
      <polyline fill={color} fillOpacity="0.08" stroke="none" points={areaPoints} />
      <polyline fill="none" stroke={color} strokeWidth="1.5" points={points} vectorEffect="non-scaling-stroke" />
    </svg>
  )
}
